import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Button } from "../../../components";
import { FormCheck, FormLabel } from "../../../components/forms";
import { ThemedSpan } from "../../../components/utilities";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { useUploadHubwiseFilesMutation } from "../../../services/headofficeadmin";
import HubwiseFilePicker from "./HubwiseFilePicker";

const defaultValues = {
    clients: null,
    holdings: null,
    hasHeader: true
}

const HubwiseFileUploadModal = ({ show, onHide }) => {

    const { control, setValue, formState: { errors }, reset, handleSubmit } = useForm({
        defaultValues
    });

    const [uploadTrigger] = useUploadHubwiseFilesMutation();

    const handleClose = () => {
        reset(defaultValues);
        onHide();
    }

    const onSubmit = async (data) => {
        handleClose();
        const formData = new FormData();
        Object.entries(data).forEach(([k, v]) => {
            formData.append(k, v);
        });

        await toast.promise(uploadTrigger(formData).unwrap(), {
            loading: "Uploading files and initiating background job...",
            success: "Background job started!",
            error: (err) => {
                console.error(err);
                return `Error uploading import files: ${err.data?.message ?? err.data}`;
            }
        });
    }

    return <Modal centered show={show} onHide={handleClose} size="lg" backdrop="static">
        <ThemedModal.Header closeButton>Hubwise Uploads</ThemedModal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
                Select the file(s) you wish to upload:

                <div className="row gy-2">
                    <div className="col-6">
                        <FormLabel>Clients:</FormLabel>
                        <Controller
                            name="clients"
                            control={control}
                            render={({ field: { value } }) => <HubwiseFilePicker
                                value={value}
                                setValue={(file) => setValue('clients', file)}
                            />}
                        />
                    </div>
                    <div className="col-6">
                        <FormLabel>Holdings:</FormLabel>
                        <Controller
                            name="holdings"
                            control={control}
                            rules={{
                                validate: (_, { clients, holdings }) => {
                                    if (clients == null && holdings == null)
                                        return "At least one Client or Holdings file must be uploaded."
                                    return true;
                                }
                            }}
                            render={({ field: { value } }) => <HubwiseFilePicker
                                value={value}
                                setValue={(file) => setValue('holdings', file)}
                            />}
                        />
                    </div>
                    <div className="col-12 text-end">
                        <Controller
                            name="hasHeader"
                            control={control}
                            render={({ field: { value } }) => <FormCheck
                                label="Do your files have headers?"
                                isChecked={value}
                                onChange={() => setValue('hasHeader', !value)}
                                disableAnimations
                            />}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <ThemedSpan variant="danger">
                    {errors.holdings?.message}
                </ThemedSpan>
                <Button variant="success" type='submit'>Submit and Start Job</Button>
            </Modal.Footer>
        </form>
    </Modal>
}

export default HubwiseFileUploadModal;